export default "__VITE_ASSET__BZEzagkf__"